import React from 'react'
import { ButtonGroup, Button } from '@nextui-org/react'
import Link from 'next/link'

export default async function ButtonSortGroup(props) {
  const { searchParams, queryParam, buttons } = props
  const sortBy = searchParams?.[queryParam]

  const defaultVariant = 'bordered'
  const activeVariant = 'solid'

  const renderButton = (label, sortValue) => {
    return (
      <Button 
        key={sortValue}
        as={Link}
        href={`?${queryParam}=${sortValue}`}
        variant={sortBy == sortValue ? activeVariant : defaultVariant}
      >
        {label}
      </Button>
    )
  }

  return (
    <>
      <ButtonGroup variant={defaultVariant}>
        {buttons && buttons.map((button) => renderButton(button.label, button.value))}
      </ButtonGroup>
    </>
  )
}
